import { render, staticRenderFns } from "./rent-details.vue?vue&type=template&id=605a146a&scoped=true"
import script from "./rent-details.vue?vue&type=script&lang=js"
export * from "./rent-details.vue?vue&type=script&lang=js"
import style0 from "./rent-details.vue?vue&type=style&index=0&id=605a146a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "605a146a",
  null
  
)

export default component.exports